import React from 'react';

import './AppStepper.scss';
import StepNavigation from "./StepNavigation/StepNavigation";

const AppStepper = ({currentStep, labelArray, updateStep}) => {
    return (
        <StepNavigation
            labelArray={labelArray}
            currentStep={currentStep}
            updateStep={updateStep}
        ></StepNavigation>
    );
};

export default AppStepper;